import { RootStore } from '@sama/app-state';
import { forOwn } from '@sama/micro-dash';
import { mixInInjectableSuperclass } from '@sama/ng-core';
import { ReplaySubject } from 'rxjs';
import { logStateToDevtools } from '../../../cross-team-shared/test-helpers/state-logging';
import { AnswersByName } from '../../../team-apis/otterdam/answers/answer';
import { H3mlState } from './h3ml-state';

export class H3mlStore<
  T extends H3mlState = H3mlState,
> extends mixInInjectableSuperclass(RootStore)<T> {
  layoutComplete$ = new ReplaySubject<void>(1);

  constructor(initialState: T) {
    super(initialState);
    this.manage(logStateToDevtools(this, 'H3mlStore'));
  }

  extractAnswersFromOutputInfo() {
    const answers: AnswersByName = {};
    forOwn(this.state().outputInfoByName, (info, name) => {
      if (info.isVisible) {
        answers[name] = info.answer;
      }
    });
    return answers;
  }
}
